import template from './switcher.html';

const DIRECTIVE_NAME = Switcher.DIRECTIVE_NAME = 'ktSwitcher';
export default function Switcher() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: SwitcherController,
        controllerAs: '$ctrl',
        scope: {
            elements: `=${DIRECTIVE_NAME}Elements`,
            onChange: `&${DIRECTIVE_NAME}OnChange`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function SwitcherController(
) {
    const vm = this;

    Object.assign(vm, {
        $onInit,
        valueSelected,
    });

    function $onInit() {
        vm.selected = vm.elements[0].id;
    }

    function valueSelected(id) {
        const index = vm.elements.findIndex((element) => element.id === id);
        vm.selected = id;

        const selection = {id, index};
        if (vm.onChange) {
            vm.onChange({selection});
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/switcher/switcher-component.js